import React from 'react';
import {BrowserRouter} from 'react-router-dom';

import {ThemeProvider} from 'styled-components';
import {Router} from './Router';
import {GlobalStyle} from './styles/global';
import {defaultTheme} from './styles/themes/default';
import {PopupWithMessage} from "./components";
import {useDispatch, useSelector} from "react-redux";
import {userFeedback} from "./app/userFeedback/selectors";
import {hideUserFeedback} from "./app/userFeedback/actions";

const App = () => {

    const feedback = useSelector(userFeedback)
    const dispatch = useDispatch()

    return (
        <ThemeProvider theme={defaultTheme}>
            <BrowserRouter>
                <Router/>
            </BrowserRouter>
            <GlobalStyle/>
            <PopupWithMessage
                isOpen={feedback.isOpen}
                title={feedback.title}
                subtitle={feedback.message}
                type={feedback.type}
                buttonTitle={feedback?.buttonTitle}
                buttonAction={() => dispatch(hideUserFeedback())}
            />

        </ThemeProvider>
    );
}

export default App
